<div class="bottom-strip" (click)="ctaAction($event)">
    <div class="left">
        <dotlottie-player autoplay="true" loop="true" class="animation" #lottie [attr.src]="lottieUrl"> </dotlottie-player>

        <div>
            <span class="heading"> {{ strip.header.text }} </span><br />
            <span class="msg">
                {{ strip.header.subtext }}
            </span>
        </div>
    </div>
    <div class="right center">
        <span>{{ strip.button.text }}</span>
        @if (strip.button.cross_button) {
            @if (isMobile) {
                <img (click)="disableStrip($event)" style="margin-left: 5px" src="{{ DEPLOY_URL }}/assets/images/ic_cross.svg" />
            }
        }
    </div>
    @if (strip.button.cross_button) {
        @if (!isMobile) {
            <span class="close-desktop" (click)="disableStrip($event)">&#10005;</span>
        }
    }
</div>
